import type { FC } from 'react'

import { cn } from '@/lib/utils'
import { getOpenStatus } from '@/lib/hours'
import { useBakeryClock } from '@/hooks/use-bakery-clock'

interface OpenStatusProps {
    className?: string
    detailClassName?: string
}

// "الان باز هستیم · تا ۶:۰۰ عصر" or "باز می‌کنیم ساعت ۷:۰۰ صبح · فردا", worked out in the bakery's time zone.
export const OpenStatus: FC<OpenStatusProps> = ({ className, detailClassName }) => {
    const now = useBakeryClock()
    const status = now ? getOpenStatus(now) : null

    return (
        <span className={cn('inline-flex flex-wrap items-center gap-x-2 gap-y-1', className)} aria-live='polite'>
            <span className={cn('size-2 shrink-0 rounded-full transition-colors duration-500', status?.isOpen ? 'bg-amber' : 'bg-line-strong')} aria-hidden='true' />

            {status ? (
                <>
                    <span className='font-medium'>
                        {status.headline}
                    </span>

                    <span className={cn('text-crust-soft', detailClassName)}>
                        {status.detail}
                    </span>
                </>
            ) : (
                <span className='text-crust-soft'>
                    هر روز باز هستیم
                </span>
            )}
        </span>
    )
}
